/*
    Options Domain Data
     - this could be generated to match options.py
*/
export const OptionType = {
    UNDEFINED:0,Call:1,Put:2
}
export function optionName(o){
    switch (parseInt(o)){
        case OptionType.Call: return "Call"
        case OptionType.Put: return "Put"
        default: return ""
    }
}

export const OptionStrategy = {
    CreditSpread:0,DebitSpread:1
}

export function strategyName(s) {
     switch (parseInt(s)) {
        case OptionStrategy.CreditSpread:
            return "credit spread"
        case OptionStrategy.DebitSpread:
            return "debit spread"
        default:
            return ""
     }
}
